import React from "react";
import Flashcard from "../shared/Flashcard";

const FlashcardFeatureCard = () => {
  const baseTop = 55; // Base top position for the first card
  const baseLeft = 45; // Base left position for the first card
  const offsetTop = -2; // How much to decrease top position for each card
  const offsetLeft = 4; // How much to increase left position for each card

  return (
    <div className="bg-[#7008E7] rounded-[32px] w-[300px] h-[500px] sm:w-[330px] sm:h-[550px] md:w-[360px] md:h-[600px] py-6 flex flex-col relative items-center border border-black border-dashed">
      <h2 className="text-white text-[24px] sm:text-[26px] md:text-[28px] font-bold text-center mb-6 sm:mb-8">
        Flashcards
      </h2>

      {/* Bottom-most card */}

      <div
        className="absolute -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 hover:-translate-y-[67%]"
        style={{
          top: `${baseTop + offsetTop * 3}%`,
          left: `${baseLeft + offsetLeft * 3}%`,
        }}
      >
        <Flashcard
          hint="The process of breaking down data into smaller components."
          question="What is data normalization?"
          subject="DBMS-201"
          color="#FF6467"
          subjectColor="#FEE685"
        />
      </div>
      {/* Third card */}
      <div
        className="absolute -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 hover:-translate-y-[67%]"
        style={{
          top: `${baseTop + offsetTop * 2}%`,
          left: `${baseLeft + offsetLeft * 2}%`,
        }}
      >
        <Flashcard
          hint="Think about scope and lifetime of variables."
          question="What's is var in js?"
          subject="JS-301"
          color="#7BF1A8"
          subjectColor="#FEE685"
        />
      </div>
      {/* Second card */}
      <div
        className="absolute -translate-x-1/2 -translate-y-1/2 transition-transform duration-300 hover:-translate-y-[67%]"
        style={{
          top: `${baseTop + offsetTop}%`,
          left: `${baseLeft + offsetLeft}%`,
        }}
      >
        <Flashcard
          hint="Think about time and space requirements."
          question="What is Big O notation used for?"
          subject="DSA-202"
          color="#DFF2FE"
          subjectColor="#FEE685"
        />
      </div>
      {/* Top card */}
      <div
        className="absolute -translate-x-1/2 -translate-y-1/2"
        style={{
          top: `${baseTop}%`,
          left: `${baseLeft}%`,
        }}
      >
        <Flashcard
          hint="A function calling itself."
          question="What is recursion in programming?"
          subject="COMP-101"
          color="#FFD230"
          subjectColor="#FEE685"
        />
      </div>
    </div>
  );
};

export default FlashcardFeatureCard;
